import React, { useEffect, useState } from 'react'
import Dataset from '../../components/Dataset'
import Header from '../../components/Header'
import './SearchResults.css'

const SearchResults = () => {
  const [searchResults, setSearchResults] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const saved = localStorage.getItem('search_results')
    if (saved) {
      try {
        setSearchResults(JSON.parse(saved))
      } catch (e) {
        console.error("Failed to parse stored results:", e)
      }
    }
    setLoading(false)

    const handler = (event) => {
      console.log("Received message:", event)
      if (event.origin !== window.location.origin) return
      if (event.data?.type === 'SET_RESULTS') {
        setSearchResults(event.data.payload)
        localStorage.setItem('search_results', JSON.stringify(event.data.payload))
        console.log("Search results received:", event.data.payload)
      }
    }

    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [])

  const clearResults = () => {
    setSearchResults([])
    localStorage.removeItem('search_results')
  }

  if (loading) {
    return (
      <div className="search-results-container">
        
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading search results...</p>
        </div>
      </div>
    )
  }

  if (searchResults.length === 0) {
    return (
      <div className="search-results-container">
        
        <div className="empty-results">
          <div className="empty-emoji">😭</div>
          <h2 className="empty-title">No datasets found</h2>
          <p className="empty-subtitle">Try different keywords for your search</p>
          <div className="empty-tips">
            <h3 className="tips-title">Search Tips:</h3>
            <ul className="tips-list">
              <li>• Use more general terms</li>
              <li>• Check your spelling</li>
              <li>• Try related keywords</li>
              <li>• Use fewer words for broader results</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="search-results-container">
      <Header />
      <div className="search-results-content">
        <div className="results-header">
          <div className="results-info">
            <h1 className="results-title">Search Results</h1>
            <span className="results-count">{searchResults.length} dataset(s) found</span>
          </div>
          <button 
            onClick={clearResults}
            className="clear-results-button"
            title="Clear all search results"
          >
            Clear Results
          </button>
        </div>
        
        <div className="results-grid">
          {searchResults.map((res) => (
            <div key={res.id} className="result-item">
              <Dataset datasetid={res.id} />
            </div>
          ))}
        </div>
        
        <div className="results-footer">
          <p className="footer-text">
            Found {searchResults.length} matching dataset(s)
          </p>
        </div>
      </div>
    </div>
  )
}

export default SearchResults